import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../Components/Modal/modal.js';
import { CANCEL_TEXT, STAFF_AUGMENTATION } from '../../Constants/strings.js';
import alertIcon from '../../Assets/images/svg/alert_icon.svg';

const DeleteResourceRequirementDialog = ({
  handleCloseAction,
  handleDeleteAction,
  isOpen,
}) => {
  const content = STAFF_AUGMENTATION;

  return (
    <FormDialog
      open={isOpen}
      title={content.REQUEST_RESOURCING.DELETE_RESOURCE_TITLE_TEXT}
      PaperProps={{}}
      dialogCss="dialog-message"
      dialogPaperCss="delete-dialog-paper"
      width={360}
      height={205}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <div className="dialog-message-text">
            {content.REQUEST_RESOURCING.DELETE_RESOURCE_MESSAGE}
          </div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + content.DELETE_STAFF_AUG_STATUS_BUTTON_ID}
      button2={content.DELETE.BUTTON_TEXT}
      button2Action={handleDeleteAction}
      button1Action={handleCloseAction}
    />
  );
};

DeleteResourceRequirementDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleDeleteAction: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default DeleteResourceRequirementDialog;
